module.exports = __webpack_public_path__ + "img/gys_15@2x.ca278c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_15@2x.png
// module id = sseH
// module chunks = 0